import { dashboardInfo } from '@/modules/api/get/dashboardInfo'
import { myCouponBooks, communitySponsors } from '@/modules/api/get/couponBooks'
import { assignedFees } from '@/modules/api/get/assignedFees'
import { nutritionTransactions } from '@/modules/api/get/nutritionTransactions'
import { menuCalendar } from '@/modules/api/get/menu'
import { unassignedFees } from '@/modules/api/get/unassignedFees'
import { assignedDeposits } from '@/modules/api/get/assignedDeposits'
import { wordwareLunchBalance } from '@/modules/api/get/wordwareLunchBalance'
import { lunchLastDeposit } from '@/modules/api/get/lunchLastDeposit'
import { tuitionContract } from '@/modules/api/get/tuitionContract'
import { affinetyActivityFees } from '@/modules/api/get/affinetyActivityFees'
import { userData } from '@/modules/api/get/userData'
import { mbaPowerschoolFees } from '@/modules/api/get/mbaPowerschoolFees'
import { corePowerschoolFees } from '@/modules/api/get/corePowerschoolFees'
import { mbaCafeLunch } from '@/modules/api/get/mbaCafeLunch'
import { unsignedContractRevisions } from '@/modules/api/get/unsignedContractRevisions'
import { familyUserInvoices } from '@/modules/api/get/familyUserInvoices'
import { unpaidInvoices } from '@/modules/api/get/invoice'
import { receipt } from '@/modules/api/get/receipt'
import { notificationSettings } from '@/modules/api/get/notificationSettings'
import { autoRefillData } from '@/modules/api/get/autoRefillData'
import { invoiceDetails } from '@/modules/api/get/invoiceDetails'
import { orderHistory } from '@/modules/api/get/orderHistory'
import { invoiceHistory } from '@/modules/api/get/invoiceHistory'
import { invoiceList } from '@/modules/api/get/invoiceList'
import { fundingSources } from '@/modules/api/get/fundingSources'
import { loggedIn } from '@/modules/api/get/loggedIn'
import { csrf } from '@/modules/api/get/csrf'
import { listLetters } from '@/modules/api/get/listLetters.ts'
import { getFormSubmissions } from '@/modules/api/get/formSubmissions.ts'
import { listStatements } from '@/modules/api/get/listStatements.ts'
import { listSignedDocuments } from '@/modules/api/get/listSignedDocuments.ts'
import { affinetyActivities } from '@/modules/api/get/affinetyActivities'
import { destinyFines } from '@/modules/api/get/destinyFines.ts'
import { incidentIqFees } from '@/modules/api/get/incidentIqFees.ts'
import { skywardFees } from '@/modules/api/get/skywardFees.ts'
import { skywardLunchBalance } from '@/modules/api/get/skywardLunchBalance.ts'
import { paymentScheduleEstimate } from '@/modules/api/get/paymentScheduleEstimate.ts'
import { studentMealSettings } from '@/modules/api/get/studentMealSettings'
import { accountSettings } from '@/modules/api/get/acountSettings'
import { billingAddress } from '@/modules/api/get/billingAddress'
import { securityQuestion } from '@/modules/api/get/securityQuestion'
import { quickpayLoad } from '@/modules/api/get/quickpayLoad'
import { getHealthData } from '@/modules/api/get/healthdata'
import { appBar } from '@/modules/api/get/appBar'
import { programs } from '@/modules/api/get/programs'
import { studentEnrollments } from '@/modules/api/get/studentEnrollments'
import { grades } from '@/modules/api/get/grades'
import { autoPaymentSettings } from '@/modules/api/get/autoPaymentSettings'
import { processingFeeConfigs } from '@/modules/api/get/processingFeeConfigs'
import { lowBalanceNoticeLevel } from '@/modules/api/get/lowBalanceNoticeLevel'
import { authorizeIframe } from '@/modules/api/get/authorizeIframe'
import { syncFundingSources } from '@/modules/api/get/syncFundingSources'
import { enrollmentFundingSources } from '@/modules/api/get/enrollmentFundingSources'
import { enrollmentAuthorizeIframe } from '@/modules/api/get/enrollmentAuthorizeIframe'
import { enrollmentSyncFundingSources } from '@/modules/api/get/enrollmentSyncFundingSources'
import { myEnrollmentInvitations } from '@/modules/api/get/myEnrollmentInvitations'
import { masterEnrollments } from '@/modules/api/get/masterEnrollments'
import { athleticsCatalog } from '@/modules/api/get/athleticsCatalog'
import { athleticsTeamSchedule } from '@/modules/api/get/athleticsTeamSchedule'
import { athleticsTeamMembers } from '@/modules/api/get/athleticsTeamMembers'
import { athleticsStudentReadiness } from '@/modules/api/get/athleticsStudentReadiness'
import { athleticsStudentSchedule } from '@/modules/api/get/athleticsStudentSchedule'
import { athleticsTeam } from '@/modules/api/get/athleticsTeam'
import { athleticsAthlete } from '@/modules/api/get/athleticsAthlete'
import { athleticsStudentRecord } from '@/modules/api/get/athleticsStudentRecord'
import { athleticsMessagesInbox } from '@/modules/api/get/athleticsMessagesInbox'
import { athleticsConversationMessages } from '@/modules/api/get/athleticsConversationMessages'
import { mcpCredentials } from '@/modules/api/get/mcpCredentials'
import { mcpConnections } from '@/modules/api/get/mcpConnections'

export const Get = {
  myCouponBooks,
  communitySponsors,
  mcpCredentials,
  mcpConnections,
  studentEnrollments,
  masterEnrollments,
  dashboardInfo,
  assignedFees,
  nutritionTransactions,
  menuCalendar,
  unassignedFees,
  assignedDeposits,
  wordwareLunchBalance,
  lunchLastDeposit,
  tuitionContract,
  userData,
  mbaPowerschoolFees,
  corePowerschoolFees,
  mbaCafeLunch,
  unsignedContractRevisions,
  familyUserInvoices,
  unpaidInvoices,
  receipt,
  notificationSettings,
  autoRefillData,
  invoiceDetails,
  orderHistory,
  invoiceHistory,
  invoiceList,
  fundingSources,
  loggedIn,
  csrf,
  listLetters,
  getFormSubmissions,
  listStatements,
  listSignedDocuments,
  affinetyActivities,
  affinetyActivityFees,
  destinyFines,
  incidentIqFees,
  skywardFees,
  skywardLunchBalance,
  paymentScheduleEstimate,
  studentMealSettings,
  accountSettings,
  billingAddress,
  securityQuestion,
  getHealthData,
  appBar,
  programs,
  grades,
  autoPaymentSettings,
  processingFeeConfigs,
  lowBalanceNoticeLevel,
  quickpayLoad,
  authorizeIframe,
  syncFundingSources,
  enrollmentFundingSources,
  enrollmentAuthorizeIframe,
  enrollmentSyncFundingSources,
  myEnrollmentInvitations,
  athleticsCatalog,
  athleticsTeamSchedule,
  athleticsTeamMembers,
  athleticsStudentReadiness,
  athleticsStudentSchedule,
  athleticsTeam,
  athleticsAthlete,
  athleticsStudentRecord,
  athleticsMessagesInbox,
  athleticsConversationMessages
}
